

import React, { useRef, useState } from "react";
import { Tag, Typography, Input, Button, Tabs, Segmented, Select, Modal, Form, DatePicker } from "antd";
import { SearchOutlined, EyeInvisibleOutlined, SendOutlined } from "@ant-design/icons"
import PrimaryNav from "../../shared/PrimaryNav";
import PageHeader from "../../shared/PageHeader";
import sampleHotel from "./sampleHotelVendor.json";
import AgTableClient from "../../shared/AgTable/AgTableClient";
import './index.scss';
import Cleartrip from "../../assets/images/Cleartrip.jpg";
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import PeopleIcon from '@mui/icons-material/People';



const columnDefs = [
    {
        headerName: "GST Trade Name",
        field: "gst_trade_name",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
        formatType: "ENTITY",
    },
    {
        headerName: "Legal Name of Business",
        field: "gst_legal_name_of_business",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Vendor Name ",
        field: "vendor_name_others_if_any",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Vendor Type",
        field: "finkraft_vendor_type",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
        formatType: "ENTITY",
    },
    {
        headerName: "GSTIN",
        field: "gstin",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Address",
        field: "address",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "City",
        field: "city",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "State",
        field: "state",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Pincode",
        field: "pincode",
        filter: "agNumberColumnFilter",
        enableRowGroup: true,
        formatType: "NUMBER",
    },
    {
        headerName: "Primary Email",
        field: "primary_email_id",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Secondary Email",
        field: "secondary_email_id",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Email List",
        field: "email_list",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Primary Phone",
        field: "primary_phone_number",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Phone Numbers",
        field: "phone_numbers",
        filter: "agNumberColumnFilter",
        enableRowGroup: true,
        formatType: "NUMBER",
    },
    {
        headerName: "Created On",
        field: "created_on",
        filter: "agDateColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Created By",
        field: "created_by",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Modified On",
        field: "modified_on",
        filter: "agDateColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Modified By",
        field: "modified_by",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Email Verified",
        field: "is_primary_email_verified",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Phone Verified",
        field: "is_primary_phone_verified",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Ingestion Source",
        field: "ingestion_source",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
    {
        headerName: "Validation Status",
        field: "validation_status",
        filter: "agTextColumnFilter",
        enableRowGroup: true,
    },
];

const rowData = sampleHotel;
console.log(rowData, "row");

const { TextArea } = Input;

function HotelVendorDetails() {
    const ref = useRef(null);
    const [form] = Form.useForm();
    const [activeTab, setActiveTab] = useState("my data");
    const [open, setOpen] = useState(false);


    return (
        <div
            style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <PageHeader
                style={{ height: '60px' }}
                leftActions={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <img src={Cleartrip} style={{ height: '40px', width: "40px" }} alt="Left Action" />
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '4px' }}>
                            <span style={{ color: "#161922", fontSize: '16px' }}>Cleartrip</span>
                            <span style={{ color: "#7D7D82", fontSize: '12px' }}>1245 Grand Avenue, Ojai, CA</span>
                        </div>
                    </div>
                }
                rightActions={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 15 20" fill="none">
                                    <path d="M14.6631 7.33592C14.6639 6.10038 14.3523 4.8847 13.7575 3.80179C13.1626 2.71888 12.3038 1.80386 11.2606 1.14172C10.2175 0.479582 9.02396 0.0918036 7.79086 0.0144022C6.55775 -0.0629992 5.32508 0.172487 4.20735 0.698988C3.08961 1.22549 2.12305 2.02593 1.39746 3.02596C0.671871 4.02599 0.210776 5.19317 0.0570051 6.4191C-0.0967659 7.64502 0.0617749 8.88993 0.517902 10.0382C0.974029 11.1864 1.71295 12.2008 2.66602 12.9871V19.333C2.66594 19.4467 2.69493 19.5585 2.75024 19.6578C2.80555 19.7571 2.88533 19.8406 2.98201 19.9004C3.07869 19.9602 3.18906 19.9942 3.30261 19.9993C3.41617 20.0044 3.52914 19.9804 3.63079 19.9295L7.33156 18.0833L11.0332 19.9337C11.126 19.9781 11.2277 20.0006 11.3306 19.9995C11.5074 19.9995 11.6769 19.9293 11.8019 19.8043C11.9269 19.6793 11.9971 19.5098 11.9971 19.333V12.9871C12.831 12.3002 13.5025 11.4373 13.9635 10.4603C14.4244 9.48323 14.6634 8.41624 14.6631 7.33592ZM1.33301 7.33592C1.33301 6.14951 1.68482 4.98976 2.34395 4.0033C3.00308 3.01684 3.93993 2.24799 5.03602 1.79398C6.13211 1.33996 7.33822 1.22117 8.50182 1.45263C9.66543 1.68408 10.7343 2.25539 11.5732 3.0943C12.4121 3.93321 12.9834 5.00205 13.2149 6.16566C13.4463 7.32926 13.3275 8.53537 12.8735 9.63146C12.4195 10.7276 11.6506 11.6644 10.6642 12.3235C9.67772 12.9827 8.51796 13.3345 7.33156 13.3345C5.74119 13.3327 4.21646 12.7001 3.0919 11.5756C1.96733 10.451 1.33478 8.92629 1.33301 7.33592ZM2.66602 7.33592C2.66602 6.41316 2.93965 5.51113 3.45231 4.74388C3.96496 3.97664 4.69362 3.37864 5.54614 3.02552C6.39865 2.6724 7.33674 2.58 8.24177 2.76002C9.14679 2.94004 9.97811 3.38439 10.6306 4.03688C11.2831 4.68937 11.7274 5.52069 11.9075 6.42571C12.0875 7.33074 11.9951 8.26882 11.642 9.12134C11.2888 9.97386 10.6908 10.7025 9.9236 11.2152C9.15635 11.7278 8.25432 12.0015 7.33156 12.0015C6.09459 12.0001 4.90866 11.5082 4.03399 10.6335C3.15932 9.75882 2.66735 8.57289 2.66602 7.33592Z" fill="#F0B100"/>
                                </svg>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ color: "#DC8225", fontSize: '14px', fontWeight: 600 }}>Hotel Bellweather</span>
                                    <span style={{ color: "#7D7D82", fontSize: '12px' }}>Top Performer</span>
                                </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                                    <path d="M17.4167 0H1.58333C1.16341 0 0.76068 0.16857 0.463748 0.468628C0.166815 0.768685 0 1.17565 0 1.6V7.19998C0 12.472 2.52542 15.667 4.64411 17.419C6.92609 19.3049 9.1962 19.9449 9.29516 19.9719C9.43123 20.0094 9.57471 20.0094 9.71078 19.9719C9.80974 19.9449 12.0769 19.3049 14.3618 17.419C16.4746 15.667 19 12.472 19 7.19998V1.6C19 1.17565 18.8332 0.768685 18.5363 0.468628C18.2393 0.16857 17.8366 0 17.4167 0ZM14.0204 6.96598L8.47875 12.566C8.40523 12.6403 8.31791 12.6994 8.22181 12.7396C8.1257 12.7799 8.02268 12.8006 7.91865 12.8006C7.81461 12.8006 7.71159 12.7799 7.61548 12.7396C7.51938 12.6994 7.43207 12.6403 7.35854 12.566L4.98354 10.166C4.83499 10.0159 4.75154 9.81226 4.75154 9.59997C4.75154 9.38768 4.83499 9.18409 4.98354 9.03397C5.13209 8.88386 5.33357 8.79953 5.54365 8.79953C5.75373 8.79953 5.9552 8.88386 6.10375 9.03397L7.91667 10.869L12.8982 5.83398C12.9718 5.75966 13.0591 5.7007 13.1552 5.66047C13.2513 5.62024 13.3543 5.59954 13.4583 5.59954C13.5624 5.59954 13.6654 5.62024 13.7615 5.66047C13.8576 5.7007 13.9449 5.75966 14.0184 5.83398C14.092 5.90831 14.1503 5.99655 14.1901 6.09367C14.23 6.19078 14.2504 6.29487 14.2504 6.39998C14.2504 6.5051 14.23 6.60918 14.1901 6.7063C14.1503 6.80341 14.092 6.89165 14.0184 6.96598H14.0204Z" fill="#00A76F"/>
                                </svg>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ color: "#10B981", fontSize: '14px', fontWeight: 600 }}>The Grand Zenith</span>
                                    <span style={{ color: "#7D7D82", fontSize: '12px' }}>Biggest Mover</span>
                                </div>
                            </div>
                        </div>
                        <div className="notification-wrapper">
                            <div className="notification-box">
                                <NotificationsActiveOutlinedIcon style={{ width: '20px', height: '20px', color: '#000' }} />
                            </div>
                            <div className="notification-dot"></div>
                        </div>
                    </div>
                }
            />
            <div className="header-section">
                <div className="header-content">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <PeopleIcon style={{ fontSize: '24px', color: '#0a8394' }} />
                        <Typography className="heading-text">Vendor Details & Rankings</Typography>
                    </div>
                    <span className="subheading-text">Here's what you need to focus on today</span>
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                    <Button 
                        style={{
                            color: '#0a8394',
                            borderColor: "#0a8394",
                            backgroundColor: 'white'
                        }}
                        onClick={() => setOpen(true)}
                    >
                      Assign Team Members
                    </Button>
                    <Button 
                        style={{
                            color: '#0a8394',
                            borderColor: "#0a8394",
                            backgroundColor: 'white'
                        }}
                        onClick={() => {
                            if (ref.current && ref.current.exportDataToCSV) {
                                ref.current.exportDataToCSV();
                            }
                        }}
                    >
                        Bulk upload contacts
                    </Button>
                    <Button
                        style={{
                            color: '#7D7D82',
                            borderColor: '#E1E6EA',
                            backgroundColor: '#F5F5F5'
                        }}
                        disabled
                    >
                        Send Invites
                    </Button>
                </div>
            </div>


            {/* ag-Grid Table */}
            <div style={{ flex: 1, marginTop: "16px", marginLeft: "20px", marginRight: "20px" }}>
                <AgTableClient
                    columnDefs={columnDefs}
                    rowData={rowData}
                    ref={ref}
                    groupPanel
                />
            </div>

            <Modal
                open={open}
                onCancel={() => {
                    setOpen(false);
                    form.resetFields();
                }}
                footer={null}
                width={600}
                maskClosable={false}
                styles={{
                    header: {
                        background: '#0a8394',
                        padding: '16px 24px',
                        borderRadius: '8px 8px 0 0',
                        borderBottom: 'none',
                        margin: 0
                    },
                    body: {
                        padding: '24px'
                    },
                    content: {
                        padding: 0
                    }
                }}
                title={
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        color: 'white',
                        width: '100%',
                        margin: 0,
                        padding: 0
                    }}>
                        <span style={{ color: 'white', fontSize: '18px', fontWeight: 600 }}>Invite Team Member</span>
                        <span 
                            onClick={() => {
                                setOpen(false);
                                form.resetFields();
                            }}
                            style={{ 
                                color: 'white', 
                                cursor: 'pointer', 
                                fontSize: '20px',
                                lineHeight: '1'
                            }}
                        >
                            ×
                        </span>
                    </div>
                }
            >
                <div style={{ marginBottom: '20px', color: '#7D7D82', fontSize: '14px' }}>
                    Assign vendor contact management to a team member
                </div>

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={(values) => {
                        console.log('Form values:', values);
                        // Handle form submission here
                        setOpen(false);
                        form.resetFields();
                    }}
                >
                    <Form.Item
                        label="Team Member Email"
                        name="email"
                        rules={[
                            { required: true, message: 'Please enter team member email' },
                            { type: 'email', message: 'Please enter a valid email address' }
                        ]}
                    >
                        <Input 
                            placeholder="colleague@company.com"
                            style={{ marginBottom: '16px' }}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Task Assignment"
                        name="taskAssignment"
                        rules={[{ required: true, message: 'Please select task type' }]}
                    >
                        <Select
                            placeholder="Select task type"
                            style={{ width: '100%', marginBottom: '16px' }}
                        >
                            <Select.Option value="vendor-onboarding">Vendor Onboarding</Select.Option>
                            <Select.Option value="contact-management">Contact Management</Select.Option>
                            <Select.Option value="compliance-review">Compliance Review</Select.Option>
                            <Select.Option value="invoice-processing">Invoice Processing</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Access Level"
                        name="accessLevel"
                        rules={[{ required: true, message: 'Please select access level' }]}
                    >
                        <Select
                            placeholder="Select access level"
                            style={{ width: '100%', marginBottom: '16px' }}
                        >
                            <Select.Option value="view-only">View Only</Select.Option>
                            <Select.Option value="edit">Edit</Select.Option>
                            <Select.Option value="admin">Admin</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Due Date"
                        name="dueDate"
                        rules={[{ required: true, message: 'Please select due date' }]}
                    >
                        <DatePicker
                            placeholder="dd/mm/yyyy"
                            style={{ width: '100%', marginBottom: '16px' }}
                            format="DD/MM/YYYY"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Additional Notes"
                        name="additionalNotes"
                    >
                        <TextArea
                            placeholder="Any specific instructions or context for the team member..."
                            rows={4}
                            style={{ marginBottom: '16px' }}
                        />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0, marginTop: '24px' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <Button
                                onClick={() => {
                                    setOpen(false);
                                    form.resetFields();
                                }}
                                style={{
                                    background: 'white',
                                    color: '#161922',
                                    borderColor: '#E1E6EA'
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    background: '#0a8394',
                                    borderColor: '#0a8394',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}
                                icon={<SendOutlined />}
                            >
                                Send Invitation
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>

        </div>
    );
}

export default HotelVendorDetails;

